import { createContext, useContext, useState, useCallback } from 'react';
import { scrollTo } from '../lib/scroll';

const OrderContext = createContext(null);

export const defaultOrder = {
  kind: 'package',
  selectionId: null,
  months: 1,
  founder: false,
  spotProduction: 'none',
  exclusivity: false,
  timeWindow: false,
  sponsoring: false,
  startDate: '',
  apptDate1: '',
  apptTime1: '',
  apptDate2: '',
  apptTime2: '',
  branche: '',
  notes: '',
  company: '',
  contactPerson: '',
  street: '',
  zip: '',
  city: '',
  email: '',
  phone: '',
  vatId: '',
  consentTerms: false,
  consentAuthority: false,
  signatureMode: 'draw',
  signatureData: null,
  typedName: '',
  ort: 'Koblenz',
  datum: new Date().toISOString().slice(0, 10),
};

const scrollToForm = () => requestAnimationFrame(() => scrollTo('#auftrag'));

export function OrderProvider({ children }) {
  const [order, setOrder] = useState(defaultOrder);

  const update = useCallback((patch) => setOrder((o) => ({ ...o, ...patch })), [setOrder]);

  const selectPackage = useCallback((id) => {
    setOrder((o) => ({
      ...o,
      kind: 'package',
      selectionId: id,
    }));
    scrollToForm();
  }, [setOrder]);

  const selectCampaign = useCallback((id) => {
    setOrder((o) => ({ ...o, kind: 'campaign', selectionId: id, founder: false }));
    scrollToForm();
  }, [setOrder]);

  const selectBeratung = useCallback(() => {
    setOrder((o) => ({ ...o, kind: 'beratung', selectionId: null, founder: false }));
    scrollToForm();
  }, [setOrder]);

  const selectFounder = useCallback(() => {
    setOrder((o) => ({
      ...o,
      kind: 'package',
      founder: true,
      months: 12,
      spotProduction: o.spotProduction === 'none' ? 'standard' : o.spotProduction,
    }));
    scrollToForm();
  }, [setOrder]);

  const resetOrder = useCallback(() => setOrder({ ...defaultOrder, datum: new Date().toISOString().slice(0, 10) }), [setOrder]);

  return (
    <OrderContext.Provider value={{ order, update, selectPackage, selectCampaign, selectBeratung, selectFounder, resetOrder }}>
      {children}
    </OrderContext.Provider>
  );
}

export const useOrder = () => useContext(OrderContext);
